import { FormControlLabel } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Switch from '../../base/ui/components/web/Switch';
import { FORM_CONTROL_LABEL_SIZE_CLASS } from '../../base/ui/constants.any';
import useMeetingAccess from '../hookss/useMeetingAccess';
import PasswordRoom from './PasswordRoom';
import { useDispatch, useSelector } from 'react-redux';
import { sendNotificationToLobby } from '../../base/util/functions';
import { LOBBY_TYPE_NOTI } from '../../lobby/constants';
const useStyles = makeStyles()((theme) => {
    return {
        controllerWrapper: {
            padding: '4px 4px 4px 17px'
        },
        formControlItem: {
            justifyContent: 'space-between',
            padding: '5.5px 15px',
            borderRadius: '6px',
            '&:hover': {
                backgroundColor: 'rgba(238, 0, 51, 0.04)',
                '& .MuiFormControlLabel-label': {
                    color: theme.palette.primary10
                }
            }
        }
    };
});
const AccessMeeting = () => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const { items } = useMeetingAccess();
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    return (React.createElement("div", { style: { marginTop: '12px' } },
        React.createElement("div", { className: 'controller-meeting-header controler-header' }, t('menuController.accessMeeting')),
        React.createElement("div", { className: cx("controler-list-item", classes.controllerWrapper) },
            React.createElement(FormControlLabel, { className: cx(FORM_CONTROL_LABEL_SIZE_CLASS.SMALL, classes.formControlItem), label: t('menuController.lockRoom'), labelPlacement: 'start', control: React.createElement(Switch, { checked: items[0]?.checked, onChange: (value) => {
                        if (value) {
                            sendNotificationToLobby(state, dispatch, LOBBY_TYPE_NOTI.ROOM_LOCKED);
                        }
                        items[0].onChange(items[0].key, value);
                    } }) }),
            React.createElement(FormControlLabel, { className: cx(FORM_CONTROL_LABEL_SIZE_CLASS.SMALL, classes.formControlItem), label: t('menuController.waitingRoom'), labelPlacement: 'start', control: React.createElement(Switch, { checked: items[1]?.checked, onChange: (value) => items[1].onChange(items[1].key, value) }) }),
            React.createElement("div", { className: "controler-item controler-item-toogle", style: { margin: 0 } },
                React.createElement(PasswordRoom, null)))));
};
/*  */
export default AccessMeeting;
